import { useCallback, useState, useEffect } from "react";
import PageTitle from "../utils/PageTitle";
import { useUserContext } from "../../contexts/UserContext";
import { catchError } from "../../services/DaoService";
import {
  Button,
  Card,
  Col,
  Divider,
  Input,
  Row,
  Select,
  Spin,
} from "antd";
import {
  PlusCircleFilled,
  ReloadOutlined,
} from "@ant-design/icons";
import {PersonnelService} from "../../services/PersonnelService";
import PersonnelCreateForm from "./PersonnelCreateForm";
import PersonnelList from "./PersonnelList";
import PropTypes from "prop-types";


export default function PersonnelListByDepartement({departement}) {
  const [paginationData, setPaginationData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [newModalVisible, setNewModalVisible] = useState(false);
  const {check} = useUserContext();
  const [searchText, setSearchText] = useState(null);
  const [statut, setStatut] = useState('tout');
  const [personnels, setPersonnels] = useState([]);

  const init = useCallback(() => {
    setLoading(true);
    PersonnelService.getInstance()
      .search({ searchText, statut, departement_id: departement.id })
      .then((response) => {
        setPaginationData(response.data);
        setPersonnels(response.data.data);
      })
      .catch((error) => {
        catchError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [searchText, statut, departement]);

  useEffect(() => {
    init();
  }, [init, check]);

  const handleCreation = () => {
    init();
  };

  const labelStyle = {
    marginRight: '10px',
    display: 'flex',
    alignItems: 'center',
  };

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  };
  return (
    <>
      <PageTitle
        title="Liste du personnel du département"
        subTitle="Visualisez et gérez les personnels du département"
        icon={<PlusCircleFilled />}
      >
        {check("CREATE-PERSONNEL") && (
          <Button
            type="primary"
            icon={<PlusCircleFilled />}
            onClick={() => setNewModalVisible(true)}
          >
            Ajouter un personnel
          </Button>
        )}
        <Button type="default" icon={<ReloadOutlined />} onClick={init}>
          Rafraîchir
        </Button>
      </PageTitle>
      <Card>
        <Row gutter={[16, 16]} justify={"center"}>
          <Col span={24}>
            <Divider>Filtres rapides</Divider>
          </Col>
          <Col xs={24} sm={12} md={8} lg={8}>
            <Input.Search
              size="large"
              value={searchText}
              onInput={(e) => setSearchText(e.target.value)}
              placeholder="Rechercher par nom ou code"
            />
          </Col>
          <Col xs={24} md={8} lg={6}>
            <div style={containerStyle}>
              <div style={labelStyle}>Statut:</div>
              <Select size="large"
                value={statut}
                onChange={(value) => {
                  setStatut(value);
                }}
                placeholder="Filtrer par statut"
                style={{ width: "100%" }}
              >
                <Select.Option value="tout">Tous les agents</Select.Option>
                <Select.Option value="actif">Agents en service</Select.Option>
                <Select.Option value="inactif">Agents hors service</Select.Option>
              </Select>
            </div>
          </Col>
        </Row>
        <Spin spinning={loading}>
          <PersonnelList personnels={personnels} setPersonnels={setPersonnels} paginationData={paginationData} setPaginationData={setPaginationData} searchParams={{searchText, departement_id: departement.id, statut}} />
        </Spin>
      </Card>

      <PersonnelCreateForm departement={departement}
        visible={newModalVisible}
        onCreate={handleCreation}
        onCancel={() => setNewModalVisible(false)}
      />
    </>
  );
}


PersonnelListByDepartement.propTypes = {
    // renseigner les props du composant ici
    departement: PropTypes.object.isRequired,
};
